<template>

    <div class="detail" >
         <!-- 设置播放器容器 -->
        <div :style="background"></div>
        <p class="videotitle">{{title}}</p>

        <canvas v-show="popupShow" :style="{'width':width+'px','height':height+'px'}" id="canvas"></canvas>
        <video v-show="!popupShow"   id="player-container-id" :poster="img" preload="auto" :width="width" :height="height" playsinline webkit-playsinline x5-playsinline></video>
        <div class="video-info">
          <van-button @click="usrpush(aid)" class="button" >查看所有视频</van-button>
          <div @click="confirminfo" class="cancel"><u>取消推送</u></div>
        </div>

        <van-popup class="popup-msg" :close-on-click-overlay="false" v-model="popupShow">
        
          <label style="font-weight:600;text-align: left;letter-spacing:2px;display:block;margin: 1rem;margin-bottom:1.6rem;">确定取消推送消息吗？取消后无法再接受到其他视频 </label>
          <van-button @click="cancel(aid)"   class="sure" >确定</van-button>
          <van-button @click="close"   class="close" >取消</van-button>
       </van-popup>
    </div>
    
</template>

<script>
import { getVideodetail,userCancle,Ceshi,videoRecord } from '@/api/api.js'

export default {

    data(){
        return{
            width:'320',
            height:"180",
            background: {
              backgroundImage:'url(' + require('../assets/images/bg.jpg') + ')',
              backgroundRepeat:"no-repeat",
              backgroundSize:"100% 100%",
              width: "100%",
              height: "100%",
              position:'fixed',
              zIndex: -10,
              top:0
             },
            fileID:'',
            title:'',
            aid:0,
            id:0,
            appid:'',
            img:'',
            player:'',
            popupShow:false,
            setInter:Object,
            canva:'',
            ctx:'', 
            videoItem:''
           
            
        }
    },
     computed: {
      
        
    },
    created(){
        
    },
    updated() {
          
    },
     mounted () {
       
       this.detail();
        window.screenWidth = document.body.clientWidth
         this.width = window.screenWidth-30;//设置视频长宽比
         this.height = this.width*(9/16);
        
    },
    methods:{
        //首页内容
          detail (){
            let id = this.$route.query.id;
            getVideodetail({id:id}).then((res)=>{                
                if(res.code==200){
                    this.fileID = res.result.fileid;
                    this.title = res.result.title;
                    this.aid = res.result.aid;
                    this.id = res.result.id;
                    this.appid = res.result.appid;
                    this.img = res.result.img;
                    this.video();  
                }
                  
               
            }),(err)=>{
                console.log(err);
            }
          },  
          Record(parames){
               videoRecord(parames).then((res)=>{                 
               
            }),(err)=>{
                console.log(err);
            }
          },
          video(){
              this.player = TCPlayer("player-container-id", { // player-container-id 为播放器容器ID，必须与html中一致
                  fileID: this.fileID, // 请传入需要播放的视频fileID 必须
                  appID: this.appid, // 请传入点播账号的appID 必须
                  autoplay: false //是否自动播放
                  //其他参数请在开发文档中查看
              });

              let _this = this;
              this.player.on("pause", function(){
               
              });
               this.player.on("ended", function(){
                
              });
               
              this.player.on("play", function(){
                  _this.Record({vid:_this.id})
              });
          },

           next(){
              if(this.popupShow){
                   this.canva =document.getElementById("canvas");
                    this.videoItem = document.getElementById("player-container-id_html5_api");
                    this.ctx = this.canva.getContext('2d');
                  //向浏览器请求一帧
                  let _this = this;
                   requestAnimationFrame(function(){
                      //绘图
                      _this.ctx.drawImage(_this.videoItem, 0, 0,_this.width,_this.height);
                
                      _this.next();
                  })
               }
          },

          //取消推送
          cancel(id){
               userCancle({aid:id}).then((res)=>{
                if(res.code==200){
                    this.popupShow = false;
                    this.player.show();
                   
                } 
                this.$toast.success(res.message)
                   
                }),(err)=>{
                    this.$toast.fail("取消失败")
                }
               
          },
          usrpush(aid){
                this.$router.push({name:'userPush',query:{aid:aid}}) 
          },
          //返回上一页
        onClickLeft(){
            this.$router.go(-1)
        },
        //确定
        confirminfo(){
          this.player.hide();
          this.popupShow = true;
          this.next();
        },
        //取消
        close(){
            this.player.show();
            this.popupShow = false;
        },
       
        
    },
    watch: {
        
    },

  beforeDestroy() {
          //离开前销毁播放器,避免重复
          this.player.dispose()
  }

       

}
</script>

<style >
@import '//imgcache.qq.com/open/qcloud/video/tcplayer/tcplayer.css';
.sure{

  background-color: #e6e6e6;
  width: 40%;
  margin-right: 1rem;
  margin-bottom: 1rem;
  border-radius: .3rem;
}
.close{
  background-color: #ffc425;
  width: 40%;
  border-radius: .3rem;
}
.popup-msg{
    width:70%;
    top:45%;
    border-radius: .5rem;
    color:#000;
  }
.video-info{
  margin-top: 12.6rem;

}
.cancel{
  margin-top:.5rem;
  font-size: 1rem;
  color:#71696d
}
.vjs-poster {
    display: inline-block;
    /* vertical-align: middle; */
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: contain;
    background-color: #000000;
    cursor: pointer;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 100%;
}
.video-js {
    display: block;
    vertical-align: top;
    box-sizing: border-box;
    color: #fff;
    background-color: #FFF;
    position: relative;
    padding: 0;
    font-size: 10px;
    line-height: 1;
    font-weight: normal;
    font-style: normal;
    font-family: Arial, Helvetica, sans-serif;
    word-break: initial;
    
    margin: auto;
}
.videotitle{
      margin-top: 5.5rem;
    color: #fff;
}
.button{
    margin:auto;
    color:#000;
    width: 95%;
    background-color:#ffc425;
    border: none;
    font-weight: 600;
    font-size: 1rem;

  }
.news_r{
    margin-top: 5.5rem;
    color: #fff;
}
.detail{
    margin:0 auto;
}
.detail img{
        width: 100% !important;
}
</style>